export default __webpack_public_path__ + "aurelia.741698db.png";